

















































































































































import TableDynamic from "@/components/TableDynamic.vue";
import TheBannerSmall from "@/components/The/TheBannerSmall.vue";
import { apiClient } from "@/services/api-client";
import { mapGetters } from "vuex";
import NoLocationSelected from "@/components/NoLocationSelected.vue";
import LoadingBlock from "@/components/LoadingBlock.vue";
import BaseIconAlert from "@/components/Base/BaseIconAlert.vue";
import BaseInfoTooltip from "@/components/Base/BaseInfoTooltip.vue";
import BaseBreadcrumb from "@/components/Base/BaseBreadcrumb.vue";
import BasePage from "@/components/Base/BasePage.vue";
import store from "@/store/store";
import { logPageMixin } from "@/mixins/LogPageMixin";
import DocumentDownloaderFaktuur from "@/components/DocumentDownloaderFaktuur.vue";
import CurrencyFormat from "@/components/CurrencyFormat.vue";

export default {
  name: "DuraFacturen",
  components: {
    BasePage,
    BaseBreadcrumb,
    BaseInfoTooltip,
    BaseIconAlert,
    LoadingBlock,
    NoLocationSelected,
    TheBannerSmall,
    TableDynamic,
    DocumentDownloaderFaktuur,
    CurrencyFormat
  },
  mixins: [logPageMixin],
  data() {
    return {
      isLoading: false,
      items: []
    };
  },
  computed: {
    ...mapGetters([
      "selectedLocationId",
      "getColumnSetting",
      "selectHasProjectSelected",
      "selectedLocationProjectId",
      "getMultiSetting",
      "getIntSetting"
    ]),
    fields() {
      return [
        {
          key: this.getColumnSetting("MaterieelFacturen_Nummer").isEnabled
            ? "factuurNummer"
            : null,
          label: this.$t("shared.nummer"),
          sortable: true,
          order: this.getColumnSetting("MaterieelFacturen_Nummer").order
        },
        {
          key: this.SetKeyKolomnDatum,
          label: this.$t("shared.datum"),
          sortable: true,
          order: this.getColumnSetting("MaterieelFacturen_Datum").order
        },
        {
          key: this.SetKeyKolomnBedrag,
          label: this.$t("shared.kosten"),
          sortable: true,
          order: this.getColumnSetting("MaterieelFacturen_Kosten").order
        },
        {
          key: this.SetKeyKolomnOpenstaandeBedrag,
          label: this.$t("Facturen.bedrag_openstaand"),
          sortable: true,
          order: this.getColumnSetting("MaterieelFacturen_Bedragopenstaand")
            .order
        },
        {
          key: this.getColumnSetting("MaterieelFacturen_Excel").isEnabled
            ? "excelDoc"
            : null,
          label: this.$t("Facturen.download_excel"),
          sortable: false,
          order: this.getColumnSetting("MaterieelFacturen_Excel").order
        },
        {
          key: this.getColumnSetting("MaterieelFacturen_Pdf").isEnabled
            ? "pdfDoc"
            : null,
          label: this.$t("Facturen.download_pdf"),
          sortable: false,
          order: this.getColumnSetting("MaterieelFacturen_Pdf").order
        }
      ];
    },
    SetKeyKolomnDatum() {
      return this.getColumnSetting("MaterieelFacturen_Datum").isEnabled
        ? "datum"
        : null;
    },
    SetKeyKolomnBedrag() {
      return this.getColumnSetting("MaterieelFacturen_Kosten").isEnabled
        ? "bedrag"
        : null;
    },
    SetKeyKolomnOpenstaandeBedrag() {
      return this.getColumnSetting("MaterieelFacturen_Bedragopenstaand")
        .isEnabled
        ? "openstaandeBedrag"
        : null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    boolSetting(settingName) {
      return this.$store.getters.getBoolSetting(settingName);
    },
    fetchData() {
      if (this.selectedLocationId === null) {
        return;
      }

      this.isLoading = true;

      if (!this.selectHasProjectSelected) {
        apiClient
          .getDuraFacturen({
            materieelLocatie: this.selectedLocationId
          })
          .then(response => {
            this.items = response.facturen;
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        apiClient
          .getDuraProjectFacturen({
            materieelLocatie: this.selectedLocationId,
            gebruikerLogin: this.$store.state.auth.username,
            projectNummer: this.selectedLocationProjectId
          })
          .then(response => {
            this.items = response.facturen;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchProjectData() {
      this.$store.dispatch("projectSelected");
      this.fetchData();
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters.getMultiSetting("Locatie_ToonDuraFacturen")) {
      next({ name: "Home" });
    }

    next();
  }
};
